import { inject } from '@angular/core';
import { AxiosResponse } from 'axios';
import { Observable } from 'rxjs';
import { OryRequestTransformer } from '../api';
import type { OryApiResponse } from '../model';

/**
 * Base class for all Ory flow implementations.
 * 
 * Provides request transformation and error handling for Ory API calls.
 * Flow implementations extend specialized base classes (`OryKratosBaseFlow` or `OryHydraBaseFlow`)
 * and implement capability interfaces (`OryCreatableFlow`, `OryRetrievableFlow`, `OryExecutableFlow`).
 */
export abstract class OryFlowBase {
  readonly #requestTransformer: OryRequestTransformer = inject(
    OryRequestTransformer,
  );

  protected fromOryRequest<ResponseType extends OryApiResponse>(
    request: Promise<AxiosResponse<ResponseType>>,
  ): Observable<ResponseType> {
    return this.#requestTransformer.fromOryRequest<ResponseType>(request);
  }
}
